import { browserHistory } from 'react-router';
import { flags } from '../../../../../common/constants/flags';
import { selectFeatureFlag } from '@flopflip/react-redux';
import receiveOffer from '../helpers/receiveOffer';
import {
  getOutlets,
  getDeliveryMethods,
  getStatusCodes,
  getPaymentMethods,
  validateOfferLookupId,
  saveOffer,
  getAllFees,
  getPriceLevelsByEvent,
  getOfferAuditLog,
  getPromotionRevisions,
} from '../../../../../api/ApiManager';
import {
  getPriceLevelsSuccess,
  getStatusCodesFailure,
  getStatusCodesSuccess,
  getPaymentMethodsSuccess,
  getPaymentMethodsFailure,
  removeTemplateOffer,
} from '../../../modules/eventDetails';
import {
  GET_OFFER_BY_ID_SUCCESS,
  GET_OFFER_BY_ID_BEGIN,
  FLAG_OFFER_IS_INCOMPLETE,
  GET_STATUS_CODES_BEGIN,
  GET_STATUS_CODES_FAILURE,
  GET_STATUS_CODES_SUCCESS,
  GET_PRICE_LEVELS_SUCCESS,
  GET_PAYMENT_METHODS_BEGIN,
  GET_PAYMENT_METHODS_FAILURE,
  GET_PAYMENT_METHODS_SUCCESS,
  GENERATE_NEW_OFFER_LOOKUP_ID,
  SET_LAST_SAVED_OFFER,
} from '../../../modules/constants';
import {
  GET_PROMO_GROUPS_BEGIN,
  GET_PROMO_GROUPS_SUCCESS,
  GET_PROMO_GROUPS_FAILURE,
  GET_PROMO_TEMPLATES_SUCCESS,
} from '../../../../Templates/common/modules/templateForm';
import { ticketLinkTypes } from '../../../../../common/constants/ticketLinkTypes';
import { updateAndRecalculateRdat } from '../../../../../common/lib/ReceiveAndFormatDates';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import camelcaseKeysDeep from 'camelcase-keys-deep';

// ------------------------------------
// constants
// ------------------------------------

export const SAVE_STATUS_CODES = 'SAVE_STATUS_CODES';
export const REDIRECT_TO_EDIT_OFFER_PAGE = 'REDIRECT_TO_EDIT_OFFER_PAGE';
export const REDIRECT_TO_OFFER_MANAGEMENT_PAGE =
  'REDIRECT_TO_OFFER_MANAGEMENT_PAGE';
export const SELECTED_TICKET_LIMIT = 'SELECTED_TICKET_LIMIT';
export const HANDLE_OFFER_NAME_INPUT = 'HANDLE_OFFER_NAME_INPUT';
export const HANDLE_OFFER_START_DATE_SAVE = 'HANDLE_OFFER_START_DATE_SAVE';
export const HANDLE_OFFER_END_DATE_SAVE = 'HANDLE_OFFER_END_DATE_SAVE';
export const STORE_CURR_OFFER_ID = 'STORE_CURR_OFFER_ID';
export const GET_OFFER = 'GET_OFFER';
export const HANDLE_OFFER_DESCRIPTION_INPUT = 'HANDLE_OFFER_DESCRIPTION_INPUT';
export const HANDLE_POPUP_NOTIFICATION_INPUT =
  'HANDLE_POPUP_NOTIFICATION_INPUT';
export const HANDLE_POPUP_NOTIFICATION_CHECKBOX =
  'HANDLE_POPUP_NOTIFICATION_CHECKBOX';

export const GET_OUTLETS_BEGIN = 'GET_OUTLETS_BEGIN';
export const GET_OUTLETS_SUCCESS = 'GET_OUTLETS_SUCCESS';
export const GET_OUTLETS_FAILURE = 'GET_OUTLETS_FAILURE';

export const SAVE_OUTLETS = 'SAVE_OUTLETS';
export const DELETE_OFFER = 'DELETE_OFFER';
export const CLEAR_OFFER = 'CLEAR_OFFER';

export const SAVE_ADMISSIONS = 'SAVE_ADMISSIONS';
export const SAVE_DELIVERY_METHODS = 'SAVE_DELIVERY_METHODS';
export const SAVE_PAYMENT_METHODS = 'SAVE_PAYMENT_METHODS';
export const SAVE_PRICE_CODES_TO_OFFER = 'SAVE_PRICE_CODES_TO_OFFER';
export const SAVE_PRICE_LEVELS_TO_OFFER = 'SAVE_PRICE_LEVELS_TO_OFFER';
export const SAVE_PROMO_CODES = 'SAVE_PROMO_CODES';
export const SAVE_OFFER_DETAILS = 'SAVE_OFFER_DETAILS';

export const UPDATE_OFFER_CMS = 'UPDATE_OFFER_CMS';
export const RESET_OFFER_DETAILS_CANCEL_CLICK =
  'RESET_OFFER_DETAILS_CANCEL_CLICK';
export const UPDATE_PROMO_CODE = 'UPDATE_PROMO_CODE';
export const SAVE_FEES = 'SAVE_FEES';
export const HANDLE_LOOKUP_ID_INPUT = 'HANDLE_LOOKUP_ID_INPUT';
export const CHECK_OFFER_LOOKUP_ID_BEGIN = 'CHECK_OFFER_LOOKUP_ID_BEGIN';
export const CHECK_OFFER_LOOKUP_ID_SUCCESS = 'CHECK_OFFER_LOOKUP_ID_SUCCESS';
export const CHECK_OFFER_LOOKUP_ID_FAILURE = 'CHECK_OFFER_LOOKUP_ID_FAILURE';

export const DIRECT_TO_EDIT_STATUS_CODES = 'DIRECT_TO_EDIT_STATUS_CODES';
export const DIRECT_TO_EDIT_PRICE_LEVELS_AND_CODES =
  'DIRECT_TO_EDIT_PRICE_LEVELS_AND_CODES';
export const DIRECT_TO_EDIT_FEES = 'DIRECT_TO_EDIT_FEES';
export const DIRECT_TO_EDIT_OUTLETS = 'DIRECT_TO_EDIT_OUTLETS';
export const DIRECT_TO_EDIT_DELIVERY_METHODS =
  'DIRECT_TO_EDIT_DELIVERY_METHODS';
export const DIRECT_TO_EDIT_PAYMENT_METHODS = 'DIRECT_TO_EDIT_PAYMENT_METHODS';
export const DIRECT_TO_PROMO_CODES = 'DIRECT_TO_PROMO_CODES';
export const DIRECT_TO_EVENT_DETAILS_PAGE = 'DIRECT_TO_EVENT_DETAILS_PAGE';
export const DIRECT_TO_EDIT_OFFER_REPORTS = 'DIRECT_TO_EDIT_OFFER_REPORTS';

export const GET_PRICE_CODES_SUCCESS = 'GET_PRICE_CODES_SUCCESS';
export const RESET_OFFER_CMS = 'RESET_OFFER_CMS';
export const GET_DELIVERY_METHODS_BEGIN = 'GET_DELIVERY_METHODS_BEGIN';
export const GET_DELIVERY_METHODS_FAILURE = 'GET_DELIVERY_METHODS_FAILURE';
export const GET_DELIVERY_METHODS_SUCCESS = 'GET_DELIVERY_METHODS_SUCCESS';
export const GET_FEES_BEGIN = 'GET_FEES_BEGIN';
export const GET_FEES_SUCCESS = 'GET_FEES_SUCCESS';
export const GET_FEES_FAILURE = 'GET_FEES_FAILURE';

export const SAVE_OFFER_BEGIN = 'SAVE_OFFER_BEGIN';
export const SAVE_OFFER_SUCCESS = 'SAVE_OFFER_SUCCESS';
export const SAVE_OFFER_FAILURE = 'SAVE_OFFER_FAILURE';

export const AUTO_PUBLISH_OFFERS_BEGIN = 'AUTO_PUBLISH_OFFERS_BEGIN';
export const AUTO_PUBLISH_OFFERS_FAILURE = 'AUTO_PUBLISH_OFFERS_FAILURE';
export const AUTO_PUBLISH_OFFERS_SUCCESS = 'AUTO_PUBLISH_OFFERS_SUCCESS';

export const GET_PRICE_LEVELS_BEGIN = 'GET_PRICE_LEVELS_BEGIN';
export const GET_PRICE_LEVELS_FAILURE = 'GET_PRICE_LEVELS_FAILURE';
export const DIRECT_TO_ADD_PROMO_CODE = 'DIRECT_TO_ADD_PROMO_CODE';
export const DIRECT_TO_EDIT_PROMO_CODE = 'DIRECT_TO_EDIT_PROMO_CODE';
export const DIRECT_TO_OFFER_DETAILS = 'DIRECT_TO_OFFER_DETAILS';
export const HANDLE_SELECT_PROMO_GROUP = 'HANDLE_SELECT_PROMO_GROUP';

export const LOAD_OFFER_AUDIT_BEGIN = 'LOAD_OFFER_AUDIT_BEGIN';
export const LOAD_OFFER_AUDIT_SUCCESS = 'LOAD_OFFER_AUDIT_SUCCESS';
export const LOAD_OFFER_AUDIT_FAILURE = 'LOAD_OFFER_AUDIT_FAILURE';

export const LOAD_CMS_PROMO_REVISIONS_BEGIN = 'LOAD_CMS_PROMO_REVISIONS_BEGIN';
export const LOAD_CMS_PROMO_REVISIONS_SUCCESS =
  'LOAD_CMS_PROMO_REVISIONS_SUCCESS';
export const LOAD_CMS_PROMO_REVISIONS_FAILURE =
  'LOAD_CMS_PROMO_REVISIONS_FAILURE';
export const SET_OFFER_AUDIT_LOG = 'SET_OFFER_AUDIT_LOG';

export const CALCULATE_PRICE_CODE_DATES_NEW_OFFER =
  'CALCULATE_PRICE_CODE_DATES_NEW_OFFER';
export const TOGGLE_IS_SAVING = 'TOGGLE_IS_SAVING';
export const TOGGLE_IS_LOADING = 'TOGGLE_IS_LOADING';
export const FETCH_MISSING_OFFER_SECTIONS = 'FETCH_MISSING_OFFER_SECTIONS';
export const FETCH_MISSING_OFFER_SECTIONS_ABORT =
  'FETCH_MISSING_OFFER_SECTIONS_ABORT';
export const SET_OFFER_IMAGE = 'SET_OFFER_IMAGE';
export const DELETE_OFFER_IMAGE = 'DELETE_OFFER_IMAGE';
export const SET_OFFER_MOBILE_IMAGE = 'SET_OFFER_MOBILE_IMAGE';
export const DELETE_OFFER_MOBILE_IMAGE = 'DELETE_OFFER_MOBILE_IMAGE';
import {
  UPDATE_NOTIFICATION,
  HIDE_NOTIFICATION,
  setDataModifiedWarning,
} from '../../../../../store/app';

// ---------------------------- --------
// Actions
// ------------------------------------

export const updateNotifications = (message, status, dismissable) => {
  return {
    type: UPDATE_NOTIFICATION,
    message,
    status,
    dismissable,
  };
};

export const hideNotifications = () => {
  return {
    type: HIDE_NOTIFICATION,
  };
};
export const setAndHideNotification = (
  message,
  status,
  duration,
  dismissable = false
) => {
  return (dispatch) => {
    dispatch(updateNotifications(message, status, dismissable));
    if (!dismissable) {
      setTimeout(() => dispatch(hideNotifications()), duration);
    }
  };
};

export const setLastSavedOffer = (offerId) => {
  return {
    type: SET_LAST_SAVED_OFFER,
    offerId,
  };
};
export const fetchMissingOfferSections = (
  sections,
  contextId,
  eventId,
  zoneId
) => {
  return {
    type: FETCH_MISSING_OFFER_SECTIONS,
    sections,
    contextId,
    eventId,
    zoneId,
  };
};
export const fetchMissingOfferSectionsAbort = () => {
  return { type: FETCH_MISSING_OFFER_SECTIONS_ABORT };
};

export const clearOffer = () => {
  return {
    type: CLEAR_OFFER,
  };
};

export const toggleIsSaving = (setting) => {
  return {
    type: TOGGLE_IS_SAVING,
    setting,
  };
};
export const toggleIsLoading = (setting) => {
  return {
    type: TOGGLE_IS_LOADING,
    setting,
  };
};

///////////////////
//Async
////////////////

export const fetchPaymentMethods = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    return getPaymentMethods(contextId)
      .then((response) => {
        const paymentMethods = response.data.PaymentMethods;
        const formattedPaymentMethods = paymentMethods.map((method) =>
          camelcaseKeysDeep(method)
        );
        dispatch(getPaymentMethodsSuccess(formattedPaymentMethods));
        return formattedPaymentMethods;
      })
      .catch((err) => {
        dispatch(getPaymentMethodsFailure(err));
      });
  };
};

export const fetchStatusCodes = (eventId) => {
  // add zoneId param when we handle multi zones
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    // const eventId = getState().createEvent.eventCreation.eventId;
    const zoneId = '1';
    // ^ Will need to change soon
    getStatusCodes(contextId, eventId, zoneId)
      .then((response) => {
        const found = response.data.StatusCodes;
        const formattedStatusCodes = found.map((code) =>
          Object.assign({}, { id: code.Id, description: code.Description })
        );
        dispatch(getStatusCodesSuccess(formattedStatusCodes));
        return formattedStatusCodes;
      })
      .catch((err) => {
        dispatch(getStatusCodesFailure(err));
      });
  };
};

export const fetchOutlets = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(getOutletsBegin());

    return getOutlets(contextId)
      .then((response) => {
        if (response.status === 200) {
          const availOutlets = response.data.Outlets;
          const formattedOutlets = [];
          availOutlets.forEach((outlet) => {
            formattedOutlets.push(camelcaseKeysDeep(outlet));
          });

          dispatch(getOutletsSuccess(formattedOutlets));
          return formattedOutlets;
        }
      })
      .catch((err) => {
        dispatch(getOutletsFailure(err));
      });
  };
};

export const checkOfferLookupId = (offId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const state = getState();
    const initialLookupId = getState().edit_offer.initialLookupId;
    const isIncompleteOffer = getState().edit_offer.incomplete;
    dispatch(checkOfferLookupIdBegin());
    if (!offId) {
      dispatch(checkOfferLookupIdFailure('This field cannot be blank'));
      return;
    }
    if (!isIncompleteOffer && offId === initialLookupId) {
      dispatch(checkOfferLookupIdSuccess());
    } else if (lookupIdExistsLocally(state, offId)) {
      dispatch(checkOfferLookupIdFailure('LookupId must be unique'));
    } else {
      validateOfferLookupId(contextId, offId).then((response) => {
        const exists = response.data.Exists;
        if (!exists) {
          dispatch(checkOfferLookupIdSuccess(exists));
        } else {
          dispatch(checkOfferLookupIdFailure('LookupId must be unique'));
        }
      });
    }
  };
};

export const fetchDeliveryMethods = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(getDeliveryMethodsBegin());
    return getDeliveryMethods(contextId)
      .then((response) => {
        const deliveryMethods = response.data.DeliveryMethods;
        const formattedDeliveryMethods = deliveryMethods.map((method) => {
          return camelcaseKeysDeep(method);
        });
        dispatch(getDeliveryMethodsSuccess(formattedDeliveryMethods));
      })
      .catch((err) => {
        dispatch(getDeliveryMethodsFailure(err));
      });
  };
};

export const getFees = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    dispatch(getFeesBegin());
    getAllFees(contextId, userName)
      .then((response) => {
        const noError = response.data.hasOwnProperty('FeeTypes');
        if (noError) {
          const feeTypes = response.data.FeeTypes;
          const formattedFees = feeTypes.map((prop) => camelcaseKeysDeep(prop));
          dispatch(getFeesSuccess(formattedFees));
        }
      })
      .catch((err) => {
        dispatch(getFeesFailure(err));
      });
  };
};
export const getPriceLevels = () => {
  return (dispatch, getState) => {
    dispatch(getPriceLevelsBegin());
    const contextId = getState().app.contextId;
    const eventId = getState().event_details.event.id;
    getPriceLevelsByEvent(contextId, eventId)
      .then((response) => {
        const noError = response.data.hasOwnProperty('PriceLevels');
        if (noError) {
          const priceLevels = cloneDeep(response.data.PriceLevels[0]);
          const formatPriceLevels = camelcaseKeysDeep(priceLevels);
          dispatch(getPriceLevelsSuccess(formatPriceLevels));
        }
      })
      .catch((err) => {
        dispatch(getPriceLevelsFailure(err));
      });
  };
};

export const saveOfferData = (offers, zoneId, parentEventHasCMS) => {
  return (dispatch, getState) => {
    dispatch(saveOfferBegin(offers));
    const contextId = getState().app.contextId;
    const eventId = getState().event_details.event.id;
    const venueId = getState().event_details.event.venueId;
    const userName = getState().app.UserName;
    const AXSEvent = parentEventHasCMS
      ? {
          EventId: parentEventHasCMS.eventId,
          StatusId: Number(parentEventHasCMS.ticketing.statusId),
        }
      : null;
    saveOffer(contextId, AXSEvent, venueId, eventId, zoneId, offers, userName)
      .then((response) => {
        const { data } = response;
        const offerSaved = data.hasOwnProperty('OfferIds');
        const responseStatus =
          (response && response.data && response.data.ResponseStatus) || {};
        const flashSeatsError =
          data.Message &&
          data.Message.match(/failure.*flash|flash.*failure/i)[0];
        const successWithWarning =
          responseStatus.Message === 'Success' &&
          responseStatus.Warnings &&
          responseStatus.Warnings.length;

        if (offerSaved) {
          const offerIds = data.OfferIds;
          dispatch(saveOfferSuccess(offerIds));
          if (flashSeatsError) {
            dispatch(
              setAndHideNotification(
                `WARNING: Offer successfully saved, but failed to create Mobile ID event for offer ${offerIds[0]} since Access Control is not configured for the Event Zone`,
                'warning',
                15000
              )
            );
          } else if (successWithWarning) {
            dispatch(
              setAndHideNotification(
                'WARNING: Offer dates configuration problem. Please check offer, price level, or price code dates.',
                'warning',
                15000
              )
            );
          } else {
            dispatch(
              setAndHideNotification(
                'Offer successfully saved.',
                'success',
                9000
              )
            );
          }

          dispatch(setLastSavedOffer(offerIds[0]));
          dispatch(removeTemplateOffer());
          dispatch(directToEventDetails(eventId));
        } else if (data.ResponseStatus.ErrorCode === '409') {
          dispatch(setDataModifiedWarning(true));
          dispatch(toggleIsSaving(false));
          dispatch(toggleIsLoading(false));
        } else {
          dispatch(
            setAndHideNotification(
              `An error occurred while saving the offer. The server responded with: ${data.ResponseStatus.Message}`,
              'error',
              6000,
              true
            )
          );
          dispatch(saveOfferFailure(response));
        }
      })
      .catch((err) => {
        dispatch(
          setAndHideNotification(
            'An error occurred while saving the offer.',
            'error',
            6000
          )
        );
        dispatch(directToEventDetails(eventId));
        dispatch(saveOfferFailure(err));
      });
  };
};

export const calculatePriceCodeRdat = () => {
  return (dispatch, getState) => {
    const anchorDates = {};
    const generalOnsaleDate = get(
      getState(),
      'event_details.event.dates.generalOnsaleDate',
      ''
    );
    const eventStartDate = get(
      getState(),
      'event_details.event.dates.eventStartDate',
      ''
    );
    const rdatFlag = selectFeatureFlag(flags.RELATIVE_DATES_FE)(getState());

    Object.assign(anchorDates, { generalOnsaleDate }, { eventStartDate });
    dispatch(updateRdatForPriceCodes(anchorDates, rdatFlag));
  };
};

const lookupIdExistsLocally = (state, id) => {
  const allOffersLookupIds = [];
  state.event_details.event.zones.forEach((zone) => {
    zone.offers.forEach((offer) => {
      allOffersLookupIds.push(offer.lookupId);
    });
  });
  if (allOffersLookupIds.includes(id)) {
    return true;
  }
  return false;
};

/**
 * Loads offer audit log.
 *f
 * @returns {function(*, *)}
 */
export const getOfferAuditLogData = (offerId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    if (contextId && offerId) {
      dispatch(loadOfferAuditBegin());
      getOfferAuditLog(contextId, offerId)
        .then((response) => {
          const data = camelcaseKeysDeep(response.data);
          dispatch(loadOfferAuditSuccess(data));
        })
        .catch((err) => {
          dispatch(loadOfferAuditFailure(err));
        });
    }
  };
};

/**
 * Loads cms promo revisions.
 *
 * @returns {function(*, *)}
 */
export const getCMSPromoRevisionData = (promotionId) => {
  return (dispatch) => {
    if (promotionId) {
      dispatch(loadCMSPromoRevisionsBegin());
      getPromotionRevisions(promotionId)
        .then((response) => {
          const data = camelcaseKeysDeep(response.data);
          dispatch(loadCMSPromoRevisionsSuccess(data));
        })
        .catch((err) => {
          dispatch(loadCMSPromoRevisionsFailure(err));
        });
    }
  };
};

///////////////////
//Routing
////////////////

export const redirectToEditOfferPage = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}`);
  return {
    type: REDIRECT_TO_EDIT_OFFER_PAGE,
  };
};

export const directToEditStatusCodes = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/statusCodes`);
  return {
    type: DIRECT_TO_EDIT_STATUS_CODES,
  };
};
export const directToEditPriceLevelsAndCodes = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/zones`);
  return {
    type: DIRECT_TO_EDIT_PRICE_LEVELS_AND_CODES,
  };
};
export const directToEditFees = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/fees`);
  return {
    type: DIRECT_TO_EDIT_FEES,
  };
};
export const directToEditOutlets = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/outlets`);
  return {
    type: DIRECT_TO_EDIT_OUTLETS,
  };
};
export const directToEditDeliveryMethods = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/deliveryMethod`);
  return {
    type: DIRECT_TO_EDIT_DELIVERY_METHODS,
  };
};
export const directToEditPaymentMethods = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/paymentMethod`);
  return {
    type: DIRECT_TO_EDIT_PAYMENT_METHODS,
  };
};
export const directToPromoCodes = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/promoCodes`);
  return {
    type: DIRECT_TO_PROMO_CODES,
  };
};
export const directToEventDetails = (eventId) => {
  browserHistory.push(`/events/${eventId}`);
  return {
    type: DIRECT_TO_EVENT_DETAILS_PAGE,
  };
};
export const directToAddPromoCode = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/promoCodes/add`);
  return {
    type: DIRECT_TO_ADD_PROMO_CODE,
  };
};
export const directToEditPromoCode = (eventId, offerId, promoCodeId) => {
  browserHistory.push(
    `/events/${eventId}/offer/${offerId}/promoCodes/edit/${promoCodeId}`
  );
  return {
    type: DIRECT_TO_EDIT_PROMO_CODE,
  };
};
export const directToOfferReports = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/reports/offer`);
  return { type: DIRECT_TO_EDIT_OFFER_REPORTS };
};

export const deleteOfferAndRedirect = (eventId, offerId) => {
  return (dispatch) => {
    dispatch(deleteOffer(offerId));
    dispatch(directToEventDetails(eventId));
  };
};

///////////////////
//Single
////////////////
export const updateRdatForPriceCodes = (anchorDates, rdatFlag) => {
  return {
    type: CALCULATE_PRICE_CODE_DATES_NEW_OFFER,
    anchorDates,
    rdatFlag,
  };
};
export const resetOfferCMS = () => {
  return { type: RESET_OFFER_CMS };
};
export const handleSelectPromoGroup = (promoGroup) => {
  return { type: HANDLE_SELECT_PROMO_GROUP, promoGroup };
};
export const updateOfferCMS = (data, offerId) => {
  return {
    type: UPDATE_OFFER_CMS,
    data,
    offerId,
  };
};
export const saveOfferDetails = (data) => {
  return {
    type: SAVE_OFFER_DETAILS,
    data,
  };
};
export const savePriceCodesToOffer = (priceCodes) => {
  return {
    type: SAVE_PRICE_CODES_TO_OFFER,
    priceCodes,
  };
};

export const savePriceLevelsToOffer = (priceLevels) => {
  return {
    type: SAVE_PRICE_LEVELS_TO_OFFER,
    priceLevels,
  };
};
export const getPriceLevelsBegin = () => {
  return {
    type: GET_PRICE_LEVELS_BEGIN,
  };
};
export const getPriceLevelsFailure = (failureMessage) => {
  return {
    type: GET_PRICE_LEVELS_FAILURE,
    failureMessage,
  };
};
export const saveOfferBegin = (offers) => {
  return {
    type: SAVE_OFFER_BEGIN,
    offers,
  };
};
export const saveOfferFailure = (failureMessage) => {
  return {
    type: SAVE_OFFER_FAILURE,
    failureMessage,
  };
};
export const saveOfferSuccess = (offerIds) => {
  return {
    type: SAVE_OFFER_SUCCESS,
    offerIds,
  };
};

export const getDeliveryMethodsBegin = () => {
  return {
    type: GET_DELIVERY_METHODS_BEGIN,
  };
};

export const getDeliveryMethodsFailure = (failureMessage) => {
  return {
    type: GET_DELIVERY_METHODS_FAILURE,
    failureMessage,
  };
};

export const getDeliveryMethodsSuccess = (deliveryMethods) => {
  return {
    type: GET_DELIVERY_METHODS_SUCCESS,
    deliveryMethods,
  };
};
const getFeesSuccess = (fees) => {
  return { type: GET_FEES_SUCCESS, fees };
};

const getFeesBegin = () => {
  return { type: GET_FEES_BEGIN };
};

const getFeesFailure = () => {
  return { type: GET_FEES_FAILURE };
};

export const storeCurrOfferId = (id) => {
  return {
    type: STORE_CURR_OFFER_ID,
    id,
  };
};

export const setOfferImage = (data) => {
  return { type: SET_OFFER_IMAGE, data };
};
export const deleteOfferImage = () => {
  return {
    type: DELETE_OFFER_IMAGE,
  };
};
export const setOfferMobileImage = (data) => {
  return { type: SET_OFFER_MOBILE_IMAGE, data };
};
export const deleteOfferMobileImage = () => {
  return {
    type: DELETE_OFFER_MOBILE_IMAGE,
  };
};
export const handleOfferStartDateSave = (date) => {
  return {
    type: HANDLE_OFFER_START_DATE_SAVE,
    date,
  };
};

export const handleOfferEndDateSave = (date) => {
  return {
    type: HANDLE_OFFER_END_DATE_SAVE,
    date,
  };
};

export const saveStatusCodes = (statusCodes) => {
  return {
    type: SAVE_STATUS_CODES,
    statusCodes,
  };
};

export const saveOutlets = (enabledOutlets) => {
  return {
    type: SAVE_OUTLETS,
    enabledOutlets,
  };
};
export const savePaymentMethods = (enabledPaymentMethods) => {
  return {
    type: SAVE_PAYMENT_METHODS,
    enabledPaymentMethods,
  };
};

export const saveDeliveryMethods = (enabledDeliveryMethods) => {
  return {
    type: SAVE_DELIVERY_METHODS,
    enabledDeliveryMethods,
  };
};

export const savePromoCodes = (promoCodes) => {
  return {
    type: SAVE_PROMO_CODES,
    promoCodes,
  };
};
export const updatePromoCode = (promoCode) => {
  return {
    type: UPDATE_PROMO_CODE,
    promoCode,
  };
};

export const saveAdmissions = (enabledAdmissions) => {
  return { type: SAVE_ADMISSIONS, enabledAdmissions };
};

export const selectedTicketLimit = (num) => {
  return {
    type: SELECTED_TICKET_LIMIT,
    num,
  };
};

export const getOutletsBegin = () => {
  return {
    type: GET_OUTLETS_BEGIN,
  };
};

export const getOutletsFailure = (failureMessage) => {
  return {
    type: GET_OUTLETS_FAILURE,
    failureMessage,
  };
};

export const getOutletsSuccess = (availOutlets) => {
  return {
    type: GET_OUTLETS_SUCCESS,
    availOutlets,
  };
};

export const deleteOffer = (offerLookupId) => {
  return {
    type: DELETE_OFFER,
    offerLookupId,
  };
};

export const checkOfferLookupIdBegin = () => {
  return {
    type: CHECK_OFFER_LOOKUP_ID_BEGIN,
  };
};
export const checkOfferLookupIdSuccess = (message) => {
  return {
    type: CHECK_OFFER_LOOKUP_ID_SUCCESS,
    message,
  };
};
export const checkOfferLookupIdFailure = (err) => {
  return {
    type: CHECK_OFFER_LOOKUP_ID_FAILURE,
    err,
  };
};

export const saveFees = (fees) => {
  return { type: SAVE_FEES, fees };
};

export const loadOfferAuditBegin = () => {
  return {
    type: LOAD_OFFER_AUDIT_BEGIN,
  };
};

export const loadOfferAuditSuccess = (data) => {
  return {
    type: LOAD_OFFER_AUDIT_SUCCESS,
    data,
  };
};

export const loadOfferAuditFailure = (err) => {
  return {
    type: LOAD_OFFER_AUDIT_FAILURE,
    err,
  };
};

export const loadCMSPromoRevisionsBegin = () => {
  return {
    type: LOAD_CMS_PROMO_REVISIONS_BEGIN,
  };
};

export const loadCMSPromoRevisionsSuccess = (data) => {
  return {
    type: LOAD_CMS_PROMO_REVISIONS_SUCCESS,
    data,
  };
};

export const loadCMSPromoRevisionsFailure = (err) => {
  return {
    type: LOAD_CMS_PROMO_REVISIONS_FAILURE,
    err,
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [REDIRECT_TO_EDIT_OFFER_PAGE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [REDIRECT_TO_OFFER_MANAGEMENT_PAGE]: () => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [SELECTED_TICKET_LIMIT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { ticketLimit: action.num });
    return newState;
  },
  [SAVE_STATUS_CODES]: (state, action) => {
    const newState = {};
    const groups = state.groups.map((group) =>
      Object.assign({}, group, { statusCodes: action.statusCodes })
    );
    Object.assign(newState, state, { groups });
    return newState;
  },
  [HANDLE_OFFER_NAME_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerName: action.text });
    return newState;
  },
  [HANDLE_OFFER_DESCRIPTION_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { purchaseFlowDescription: action.text });
    return newState;
  },
  [HANDLE_POPUP_NOTIFICATION_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { popupNotification: action.text });
    return newState;
  },
  [HANDLE_POPUP_NOTIFICATION_CHECKBOX]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { popupNotificationEnabled: action.value });
    return newState;
  },
  [HANDLE_OFFER_START_DATE_SAVE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { startDate: action.date });
    return newState;
  },
  [HANDLE_OFFER_END_DATE_SAVE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { endDate: action.date });
    return newState;
  },
  [STORE_CURR_OFFER_ID]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { currOfferId: action.id });
    return newState;
  },
  [SET_OFFER_IMAGE]: (state, { data }) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { offerImage: data },
      { isNewOfferImage: true }
    );
    return newState;
  },
  [DELETE_OFFER_IMAGE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerImage: action.text });
    return newState;
  },
  [SET_OFFER_MOBILE_IMAGE]: (state, { data }) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { offerMobileImage: data },
      { isNewOfferMobileImage: true }
    );
    return newState;
  },
  [DELETE_OFFER_MOBILE_IMAGE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerMobileImage: action.text });
    return newState;
  },
  [GET_OUTLETS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_OUTLETS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.failureMessage });
    return newState;
  },
  [GET_OUTLETS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { availOutlets: action.availOutlets });
    return newState;
  },
  [SAVE_OUTLETS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { outlets: action.enabledOutlets });
    return newState;
  },

  [SAVE_ADMISSIONS]: (state, action) => {
    return Object.assign({}, state, { admissions: action.enabledAdmissions });
  },
  [DELETE_OFFER]: () => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [SAVE_DELIVERY_METHODS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      deliveryMethods: action.enabledDeliveryMethods,
    });
    return newState;
  },
  [GET_STATUS_CODES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_STATUS_CODES_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.failureMessage });
    return newState;
  },
  [GET_STATUS_CODES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { availStatusCodes: action.statusCodes });
    return newState;
  },
  [SAVE_PROMO_CODES]: (state, action) => {
    const newState = {};
    const promoCodes = cloneDeep(state.promoCodes);
    promoCodes.unshift(action.promoCodes);
    Object.assign(newState, state, { promoCodes });
    return newState;
  },
  [UPDATE_PROMO_CODE]: (state, action) => {
    const newState = {};
    const promoCodes = state.promoCodes.map((promo) => {
      if (promo.id === action.promoCode.id) {
        return Object.assign({}, promo, {
          promotionCode: action.promoCode.promotionCode,
          limit: action.promoCode.limit,
        });
      }
      return promo;
    });
    Object.assign(newState, state, { promoCodes });
    return newState;
  },
  [GET_PAYMENT_METHODS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_PAYMENT_METHODS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.failureMessage });
    return newState;
  },
  [GET_PAYMENT_METHODS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      availPaymentMethods: action.paymentMethods,
    });
    return newState;
  },
  [SAVE_PRICE_LEVELS_TO_OFFER]: (state, action) => {
    const newState = {};
    const groups = state.groups.map((group) =>
      Object.assign({}, group, { priceLevels: action.priceLevels })
    );
    Object.assign(newState, state, { groups });
    return newState;
  },
  [SAVE_PRICE_CODES_TO_OFFER]: (state, action) => {
    const newState = {};
    // we are only handling 1 offer group functionality
    const groups = state.groups.map((group) =>
      Object.assign({}, group, { priceCodes: action.priceCodes })
    );
    Object.assign(newState, state, { groups });
    return newState;
  },
  [SAVE_PAYMENT_METHODS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      paymentMethods: action.enabledPaymentMethods,
    });
    return newState;
  },
  [SAVE_FEES]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { fees: action.fees });
    return newState;
  },
  [HANDLE_LOOKUP_ID_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerLookupId: action.text });
    return newState;
  },
  [CHECK_OFFER_LOOKUP_ID_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { lookupIdErrorMessage: '' });
    return newState;
  },
  [CHECK_OFFER_LOOKUP_ID_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { lookupIdErrorMessage: action.err });
    return newState;
  },
  [DIRECT_TO_EDIT_STATUS_CODES]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_EDIT_PRICE_LEVELS_AND_CODES]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [DIRECT_TO_EDIT_FEES]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_EDIT_OUTLETS]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_EDIT_DELIVERY_METHODS]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_EDIT_PAYMENT_METHODS]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_PROMO_CODES]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_FEES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { availFees: action.fees });
    return newState;
  },
  [GET_DELIVERY_METHODS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      availDeliveryMethods: action.deliveryMethods,
    });
    return newState;
  },
  [GET_FEES_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_FEES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_DELIVERY_METHODS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_DELIVERY_METHODS_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_OFFER_BY_ID_BEGIN]: (state) => {
    const newState = {};
    //Note : resetting incomplete to false as it's not being reset once set to true.
    // As a good measure, resetting to it's initial state which is false
    Object.assign(newState, state, { isLoading: true, incomplete: false });
    return newState;
  },
  [GET_OFFER_BY_ID_SUCCESS]: (state, action) => {
    const newState = {};
    const onPrices = true;
    const formattedOffer = receiveOffer(
      action.offer,
      action.flag,
      state.incomplete,
      onPrices
    );
    const axsPromotion = formattedOffer.axsPromotion;
    const offerSavedWithSeparatePromo =
      (axsPromotion &&
        axsPromotion.ticketLinkType === ticketLinkTypes.SEPARATE_PROMOTION) ||
      false;

    if (!state.incomplete) {
      Object.assign(
        newState,
        state,
        formattedOffer,
        { axsPromotion },
        { offerSavedWithSeparatePromo },
        {
          initialOfferName: action.offer.offerName,
          linkedZones: [action.zone],
          initialLookupId: action.offer.offerLookupId,
          version: action.offer.version,
          isLoading: false,
          incomplete: false,
          offerLabels: action.offerLabels,
          featuredOffers: action.featuredOffers,
          isOfferPriceLevelOnSaleOffSaleDatesEnabled:
            action.isOfferPriceLevelOnSaleOffSaleDatesEnabled,
        }
      );
    } else {
      Object.assign(
        newState,
        state,
        formattedOffer,
        { promoCodes: [] },
        { axsPromotion },
        { offerSavedWithSeparatePromo },
        { offerLookupId: state.offerLookupId },
        {
          linkedZones: [action.zone],
          version: action.offer.version,
          offerName: action.offer.offerName,
          initialLookupId: action.offer.offerLookupId,
          isLoading: false,
          offerLabels: action.offerLabels,
          featuredOffers: action.featuredOffers,
          isOfferPriceLevelOnSaleOffSaleDatesEnabled:
            action.isOfferPriceLevelOnSaleOffSaleDatesEnabled,
        }
      );
    }
    return newState;
  },
  [SAVE_OFFER_BEGIN]: (state) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { isSavingOffer: true },
      { isLoading: true }
    );
    return newState;
  },
  [SAVE_OFFER_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSavingOffer: false, isLoading: false });
    return newState;
  },
  [SAVE_OFFER_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSavingOffer: false });
    return newState;
  },
  [GET_PRICE_LEVELS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [GET_PRICE_LEVELS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      availPriceLevels: action.priceLevels,
      isLoading: false,
    });
    return newState;
  },
  [GET_PRICE_CODES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { availPriceCodes: action.priceCodes });
    return newState;
  },
  [GET_PRICE_LEVELS_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DIRECT_TO_EVENT_DETAILS_PAGE]: () => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [FLAG_OFFER_IS_INCOMPLETE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { incomplete: true });
    return newState;
  },
  [SAVE_OFFER_DETAILS]: (state, action) => {
    const newState = {};
    const {
      startDate,
      endDate,
      offerName,
      offerLookupId,
      ticketLimit,
      purchaseFlowDescription,
      popupNotificationEnabled,
      popupNotification,
      queueIt,
      visibilityStartDate,
      visibilityEndDate,
      allowPublicSeatChange,
      allowEmptySingleSeats,
      isAxsInviteEnabled,
      defaultReleaseStatusCodeId,
      nonRequireContiguousSeats,
      mmcMapId,
      offerMobileImage,
      offerImage,
      hybridListViewGeneralSetting,
      hybridListViewDesktopSetting,
      hybridListViewMobileSetting,
      offerLabel,
      featuredOffer,
    } = action.data;
    const dates = {
      startDate: { ...startDate },
      endDate: { ...endDate },
      visibilityStartDate: { ...visibilityStartDate },
      visibilityEndDate: { ...visibilityEndDate },
    };
    Object.assign(newState, state, {
      offerName,
      offerLookupId,
      ticketLimit,
      purchaseFlowDescription,
      popupNotification,
      popupNotificationEnabled,
      queueIt,
      dates,
      allowPublicSeatChange,
      allowEmptySingleSeats,
      isAxsInviteEnabled,
      defaultReleaseStatusCodeId,
      nonRequireContiguousSeats,
      mmcMapId,
      offerMobileImage,
      offerImage,
      hybridListViewGeneralSetting,
      hybridListViewDesktopSetting,
      hybridListViewMobileSetting,
      offerLabel,
      featuredOffer,
    });
    return newState;
  },
  [UPDATE_OFFER_CMS]: (state, action) => {
    const axsPromotion = { ticketLinkType: action.data.ticketLink };
    if (
      Number(axsPromotion.ticketLinkType) === ticketLinkTypes.SEPARATE_PROMOTION
    ) {
      const {
        promoName,
        promoDescription,
        promoShortDescription,
        promoGroup,
        promoTemplate,
        status,
        display,
        contentStatus,
        modifiedUTC,
        dates,
      } = action.data;
      Object.assign(axsPromotion, {
        promoName,
        promoDescription,
        promoShortDescription,
        promoGroup,
        promoTemplate,
        status,
        display,
        contentStatus,
        modifiedUTC,
        dates,
      });
    }
    const newState = {};
    Object.assign(newState, state, { axsPromotion }, { allPromoTemplates: [] });
    return newState;
  },
  [RESET_OFFER_CMS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { axsPromotion: null });
    return newState;
  },
  [HANDLE_SELECT_PROMO_GROUP]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { promoGroup: action.promoGroup });
    return newState;
  },
  [GET_PROMO_GROUPS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoadingPromoGroups: true });
    return newState;
  },
  [GET_PROMO_GROUPS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      error: action.err,
      isLoadingPromoGroups: false,
    });
    return newState;
  },
  [GET_PROMO_GROUPS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      allPromoGroups: action.promoGroups,
      isLoadingPromoGroups: false,
    });
    return newState;
  },
  [GET_PROMO_TEMPLATES_SUCCESS]: (state, action) => {
    const newState = {};
    const allPromoTemplates = action.promoTemplates.length
      ? action.promoTemplates.map((template) => {
          const defaultTemplate = template.promoTemplateDefault;
          return Object.assign(
            {},
            { id: Number(template.id) },
            { name: defaultTemplate.defaultName },
            { promoName: defaultTemplate.defaultTemplateName },
            { promoShortDescription: defaultTemplate.defaultShortDescription },
            { promoDescription: defaultTemplate.defaultDescription }
          );
        })
      : [];
    Object.assign(newState, state, { allPromoTemplates });
    return newState;
  },
  [GENERATE_NEW_OFFER_LOOKUP_ID]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerLookupId: action.id });
    return newState;
  },
  [CLEAR_OFFER]: (state) => {
    const newState = {};
    Object.assign(newState, state, initialState);
    return newState;
  },
  [TOGGLE_IS_SAVING]: (state, { setting }) => {
    const newState = {};
    Object.assign(newState, state, { isSavingOffer: setting });
    return newState;
  },
  [TOGGLE_IS_LOADING]: (state, { setting }) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: setting });
    return newState;
  },
  [LOAD_OFFER_AUDIT_BEGIN]: (state) => {
    return { ...state };
  },
  [LOAD_OFFER_AUDIT_SUCCESS]: (state, { data }) => {
    return {
      ...state,
      offerAuditLog: data.items,
    };
  },
  [LOAD_OFFER_AUDIT_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.err };
  },
  [LOAD_CMS_PROMO_REVISIONS_BEGIN]: (state) => {
    return { ...state };
  },
  [LOAD_CMS_PROMO_REVISIONS_SUCCESS]: (state, { data }) => {
    const revisions = data.results;
    return {
      ...state,
      cmsPromoRevisions: revisions,
    };
  },
  [LOAD_CMS_PROMO_REVISIONS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.err };
  },
  [CALCULATE_PRICE_CODE_DATES_NEW_OFFER]: (
    state,
    { anchorDates, rdatFlag }
  ) => {
    const newState = {};
    const { generalOnsaleDate, eventStartDate } = anchorDates;
    // TODO : Discuss how to handle more than one group
    const priceCodes = cloneDeep(state.groups[0].priceCodes);

    const newPriceCodes = priceCodes.map((pCode) => {
      if (pCode.dates) {
        const start = pCode.dates && pCode.dates.startDate;
        const end = pCode.dates && pCode.dates.endDate;
        const startDate = Object.assign({}, start, {
          date: updateAndRecalculateRdat(
            start,
            generalOnsaleDate,
            eventStartDate,
            rdatFlag
          ),
        });
        const endDate = Object.assign({}, end, {
          date: updateAndRecalculateRdat(
            end,
            generalOnsaleDate,
            eventStartDate,
            rdatFlag
          ),
        });
        const dates = Object.assign(
          {},
          { ...pCode.dates },
          { startDate },
          { endDate }
        );
        Object.assign(pCode, { dates });
      }
      return pCode;
    });

    const groups = state.groups.map((group) =>
      Object.assign({}, group, { priceCodes: newPriceCodes })
    );
    Object.assign(newState, state, { groups });
    return newState;
  },
  [FETCH_MISSING_OFFER_SECTIONS]: (state) => {
    return { ...state };
  },
  [FETCH_MISSING_OFFER_SECTIONS_ABORT]: (state) => {
    return { ...state };
  },
  [DIRECT_TO_EDIT_OFFER_REPORTS]: (state) => {
    return { ...state };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  allPromoGroups: [],
  allPromoTemplates: [],
  axsPromotion: {},
  availDeliveryMethods: [],
  availFees: [],
  availOutlets: [],
  availPriceLevels: [],
  availPriceCodes: [],
  currOfferId: '',
  dates: {
    startDate: {
      date: '',
    },
    endDate: {
      date: '',
    },
  },
  deliveryMethods: [],
  promoDescription: '',
  promoShortDescription: '',
  purchaseFlowDescription: ' ', // default value needs empty space
  popupNotification: ' ',
  popupNotificationEnabled: false,
  enabledStatusCodes: [],
  fees: [],
  groups: [],
  incomplete: false,
  initialLookupId: '',
  initialOfferName: '',
  initialOfferDetails: {},
  isLoading: true,
  isLoadingPromoGroups: false,
  isSavingOffer: false,
  lookupIdErrorMessage: '',
  offerLookupId: '',
  offerName: '',
  outlets: [],
  paymentMethods: [],
  promoCodes: [],
  promoGroup: {},
  queueIt: false,
  allowPublicSeatChange: false,
  allowEmptySingleSeats: false,
  nonRequireContiguousSeats: false,
  mmcMapIdErrorMessage: '',
  mmcMapId: '',
  isNewOfferMobileImage: false,
  isNewOfferImage: false,
  offerMobileImage: '',
  offerImage: '',
  ticketLimit: '',
  zoneId: '',
  offerAuditLog: [],
  cmsPromoRevisions: [],
  combinedOfferAuditLogs: [],
  isAxsInviteEnabled: false,
  defaultReleaseStatusCodeId: null,
};

export default function editOfferReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/EditOffer/modules/EditOfferModule.js